import { Protocol } from "@orbital/games-frontend-library";

export const startRound = (bet: string, func: any) => {
  func(Protocol.START_ROUND, parseFloat(bet));
};
export const stepRound = (step: any, func: any) => {
  func(Protocol.STEP_ROUND, step);
};
export const endRound = (func: any) => {
  func(Protocol.END_ROUND);
};
export const startDoubleUp = (func: any) => {
  func(Protocol.DOUBLE_UP);
};
export const stepDoubleUp = (step: string, func: any) => {
  func(Protocol.DOUBLE_UP_ANSWER, step);
};
